export default "__VITE_ASSET__BJ6hT74N__"